/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Date fns
import { addMinutes, format } from "date-fns";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDynamicColumn,
  createProductionPlan,
  deleteProductionPlan,
  editRequiredQty,
  getDynamicColumn,
  getItemMaster,
  getPublishedProductionPlan,
  getSubModulesByRoleId,
  publishProductionPlan,
  uploadForProductionPlan,
} from "../../../store";

// React-Select component and styling
import "../../../index.css";

// config file
import Config from "../../../config/index";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import EditButton from "components/standardized-components/EditButton";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: "fit-content",
  maxHeight: "90%",
  overflow: "auto",
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const PublishedProductionPlan = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  editRequiredQty,

  getPublishedProductionPlan,
  getPublishedProductionPlanReducer,
  getDynamicColumnReducer,
  getDynamicColumn,
  createDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  const subModuleId = "70f44231-6c66-4011-8033-28634b8df7ad";

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);
  const [uncheck, setUncheck] = useState(false);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let productionPlanModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "70f44231-6c66-4011-8033-28634b8df7ad",
  );

  let viewAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "4058c3fd-5960-4ef0-9875-4653f73d1ad4",
      )
    : null;

  let editAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "8346897f-4c90-43ff-a888-29959fd97c6e",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  useEffect(() => {
    getPublishedProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      // { Header: "Part Code/Description", accessor: "partDesc" },
      { Header: "Item Code", accessor: "itemCode" },
      // { Header: "Vendor Code", accessor: "vendorCode" },
      { Header: "Purchase Date", accessor: "date" },
      // { Header: "po number", accessor: "purchaseOrderNumber" },
      // { Header: "po line number", accessor: "purchaseOrderLineNumber" },
      { Header: "Qty", accessor: "qty" },
      { Header: "Unloading Point", accessor: "unloadingPoint" },
      { Header: "Delivery Plant", accessor: "deliveryPlant" },
      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempAsset = [];
    let data = getPublishedProductionPlanReducer.published.data
      ? getPublishedProductionPlanReducer.published.data
      : [];

    setLoading(getPublishedProductionPlanReducer.loading);
    setPaginationObj(getPublishedProductionPlanReducer?.published?.pagination);
    data.map((plans) => {
      const formatDate = new Date(plans.date);

      const plansObject = {
        privateKey: plans.productionPlanId,
        date: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "do MMMM yyyy",
        ),
        qty: plans.qty,
        productionPlanId: plans.productionPlanId,
        isPublished: plans.isPublished,
        purchaseOrderNumber: plans.purchaseOrderNumber,
        purchaseOrderLineNumber: plans.purchaseOrderLineNumber,
        itemCode: plans.itemCode,
        vendorCode: plans.vendorCode,
        unloadingPoint:
          plans.unloadingPoint == "undefined" ? "NA" : plans.unloadingPoint,
        deliveryPlant:
          plans.deliveryPlant == "undefined" ? "NA" : plans.deliveryPlant,

        isEditable: plans.isEditable,
        action: (
          <div>
            {editAccess && (
              <EditButton
                tooltip="Edit"
                disabled={plans.isUpdatable === 0}
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateProductionModal(plans)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </div>
        ),
      };
      viewAccess && tempAsset.push(plansObject);
    });

    setState({ ...state, rows: tempAsset });
  }, [getPublishedProductionPlanReducer]);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayStr = today.toISOString().split("T")[0];

  const [buttonName, setButtonName] = useState("Create");

  const [openUpdateProductionModal, setOpenUpdateProductionModal] =
    useState(false);
  const [singleProductionDataForUpdate, setProductionDataForUpdate] = useState(
    {},
  );
  const handleOpenUpdateProductionModal = (Asset = {}) => {
    setProductionDataForUpdate(Asset);
    setOpenUpdateProductionModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateProductionModal = () => {
    setOpenUpdateProductionModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 4000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    reqQty: singleProductionDataForUpdate.qty,
    eDate: singleProductionDataForUpdate.date?.slice(0, 10),
  };
  // const today = new Date();
  // today.setHours(0, 0, 0, 0); // Set to start of the day
  // const todayStr = today.toISOString().split('T')[0];

  const validationSchemaForUpdate = Yup.object({
    eDate: Yup.date().min(today, "Date cannot be in the past!"),
    // .required("Enter the asset name!"),
  });
  //   const validationSchemaForUpdate = Yup.object({
  //     eDate: Yup.string().required("Enter the asset name!"),
  //     assetCode: Yup.string().required("Enter the asset code!"),
  //   });

  const [editButtonName, setEditButtonName] = useState("Submit");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      productionPlanId: singleProductionDataForUpdate.productionPlanId,
      qty: values.reqQty,
      date: values.eDate,
      userId: userId,
    };

    let res = await editRequiredQty(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getPublishedProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const headers = [
    {
      label: "date",
      key: "date",
    },
    // {
    //   label: "purchaseOrderNumber",
    //   key: "purchaseOrderNumber",
    // },
    // {
    //   label: "purchaseOrderLineNumber",
    //   key: "purchaseOrderLineNumber",
    // },
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "qty", key: "qty" },

    { label: "unloadingPoint", key: "unloadingPoint" },
    { label: "deliveryPlant", key: "deliveryPlant" },
  ];
  const csvLink = {
    filename: "Production Plan Template.csv",
    headers: headers,
    data: [],
  };
  const csvLink2 = {
    filename: "Production Plan.csv",
    headers: headers,
    data: rows,
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getPublishedProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <div>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {/* {createAssetAccess && ( */}

              <MDBox mt={0}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  tableSearch
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  serverSidePagination
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  options={{ draggable: false }}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              </MDBox>

              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openUpdateProductionModal}
                onClose={handleCloseUpdateProductionModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Update
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseUpdateProductionModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6"> Qty</MDTypography>
                        <MDInput
                          type="number"
                          name="reqQty"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.reqQty}
                          error={
                            formikForUpdate.touched.reqQty &&
                            formikForUpdate.errors.reqQty &&
                            true
                          }
                          inputProps={{
                            maxLength: 45,
                          }}
                        />
                        {formikForUpdate.touched.reqQty &&
                          formikForUpdate.errors.reqQty && (
                            <TextError msg={formikForUpdate.errors.reqQty} />
                          )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography variant="h6"> Date</MDTypography>
                        <MDInput
                          type="date"
                          name="eDate"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.eDate}
                          error={
                            formikForUpdate.touched.eDate &&
                            formikForUpdate.errors.eDate &&
                            true
                          }
                          inputProps={{
                            maxLength: 45,
                          }}
                        />
                        {formikForUpdate.touched.eDate &&
                          formikForUpdate.errors.eDate && (
                            <TextError msg={formikForUpdate.errors.eDate} />
                          )}
                      </MDBox>
                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsgForUpdate}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Updated successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={
                            !formikForUpdate.isValid ||
                            editButtonName === "Please wait..."
                          }
                        >
                          {editButtonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getPublishedProductionPlanReducer: state.getPublishedProductionPlanReducer,
    // profileData: state.profile,
    itemMaster: state.itemMaster,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getPublishedProductionPlan: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getPublishedProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    deleteProductionPlan: (productionPlanId, userId, jwtToken) =>
      dispatch(deleteProductionPlan(productionPlanId, userId, jwtToken)),
    publishProductionPlan: (payload, jwtToken) =>
      dispatch(publishProductionPlan(payload, jwtToken)),
    createProductionPlan: (payload, jwtToken) =>
      dispatch(createProductionPlan(payload, jwtToken)),
    editRequiredQty: (payload, jwtToken) =>
      dispatch(editRequiredQty(payload, jwtToken)),
    uploadForProductionPlan: (payload, jwtToken) =>
      dispatch(uploadForProductionPlan(payload, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),

    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PublishedProductionPlan);
